import { DrawCabinet } from "$src/CGS/domain/dto/article/Cabinet/DrawCabinet";
import DrawS1CabinetShape from "$src/CGS/domain/dto/article/shape/CabinetShapes/DrawS1CabinetShape";
import { DrawS20CabinetShape } from "$src/CGS/domain/dto/article/shape/CabinetShapes/DrawS20CabinetShape";
import { CabinetS1ShapeGenerator } from "./ShapeGenerators/CabinetS1ShapeGenerator";
import { CabinetS20ShapeGenerator } from "./ShapeGenerators/CabinetS20ShapeGenerator";
import { ICabinetShapeGenerator } from "./ShapeGenerators/ICabinetShapeGenerator";
import { ICabinetShapeGeneratorParameters } from "./ShapeGenerators/ICabinetShapeGeneratorParameters";


export class CabinetGeneratorFactory {
    public static GetGenerator(drawData: DrawCabinet, parameters: ICabinetShapeGeneratorParameters | null = null): ICabinetShapeGenerator | null {
        
        const cabinetShape = drawData.CabinetShape;

        switch (true) {
            case cabinetShape instanceof DrawS1CabinetShape:
                return new CabinetS1ShapeGenerator(drawData, parameters);
                // case cabinetShape instanceof DrawS18CabinetShape:
                // return new CabinetS18ShapeGenerator(drawData, parameters);
            case cabinetShape instanceof DrawS20CabinetShape:
                return new CabinetS20ShapeGenerator(drawData, parameters);
                // case cabinetShape instanceof DrawS21CabinetShape:
                // return new CabinetS21ShapeGenerator(drawData, parameters);
                // case cabinetShape instanceof DrawS27CabinetShape:
                // return new CabinetS27ShapeGenerator(drawData, parameters);
                // case cabinetShape instanceof DrawS51CabinetShape:
                // return new CabinetS51ShapeGenerator(drawData, parameters);
            default:
                return null;
        }
    }
}